module.exports = __webpack_public_path__ + "static/media/1POLICY37.7a9a595e.jpg";